import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useSideSheetClassName } from './hooks/useSideSheetClassName';
import { Backdrop } from '../Backdrop';
import { SideSheetRoot, SideSheetWindow, SideSheetContent, SideSheetHeaderContainer, SideSheetCloseButton } from './style';
import { SIDE_SHEET_CLASS_PREFIX } from './constants';
import { PortalToBody } from '../../system/util/PortalToBody';
import { useSideSheet } from './hooks/useSideSheet';
import { extendChildrenWithProps, extractContentSections } from './utils';
export var SideSheet = forwardRef(function SideSheet(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(SIDE_SHEET_CLASS_PREFIX);

  var _useSideSheet = useSideSheet(props, ref),
      portalProps = _useSideSheet.portalProps,
      rootProps = _useSideSheet.rootProps,
      getBackdropProps = _useSideSheet.getBackdropProps,
      windowProps = _useSideSheet.windowProps,
      contentProps = _useSideSheet.contentProps,
      headerContainerProps = _useSideSheet.headerContainerProps,
      getCloseButtonProps = _useSideSheet.getCloseButtonProps,
      enableBackdrop = _useSideSheet.enableBackdrop,
      enableCloseButton = _useSideSheet.enableCloseButton,
      wide = _useSideSheet.wide,
      isFixed = _useSideSheet.isFixed;

  var classOverride = useSideSheetClassName(SIDE_SHEET_CLASS_PREFIX, className, !enableBackdrop, wide);
  var childrenWithExtendedProps = extendChildrenWithProps(children, {
    classOverride: classOverride,
    isFixed: isFixed,
    theme: theme
  });

  var _extractContentSectio = extractContentSections(childrenWithExtendedProps),
      header = _extractContentSectio.header,
      body = _extractContentSectio.body,
      footer = _extractContentSectio.footer;

  return React.createElement(PortalToBody, Object.assign({}, portalProps), React.createElement(SideSheetRoot, Object.assign({}, rootProps, {
    className: classOverride.Root,
    theme: theme
  }), enableBackdrop && React.createElement(Backdrop, Object.assign({}, getBackdropProps(), {
    className: classOverride.Backdrop,
    theme: theme
  })), React.createElement(SideSheetWindow, Object.assign({}, windowProps, {
    className: classOverride.Window,
    theme: theme
  }), React.createElement(SideSheetContent, Object.assign({}, contentProps, {
    className: classOverride.Content,
    theme: theme
  }), React.createElement(SideSheetHeaderContainer, Object.assign({}, headerContainerProps, {
    className: classOverride.HeaderContainer,
    theme: theme
  }), header, enableCloseButton ? React.createElement(SideSheetCloseButton, Object.assign({
    theme: theme
  }, getCloseButtonProps())) : null), body, footer))));
});
SideSheet.displayName = SIDE_SHEET_CLASS_PREFIX;
SideSheet.defaultProps = {
  disableOverlay: false,
  disableEffects: false,
  disableCloseByEscape: false,
  isCloseButtonVisible: true,
  isFixed: true,
  open: false,
  wide: false
};